async function postLogin(username: string, password: string): Promise<void> {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: [['Content-Type', 'application/json']],
        body: JSON.stringify({ username, password }),
    });
    if (!response.ok) {
        throw new Error('Login failed');
    }
}

async function postLogout(): Promise<void> {
    await fetch(`${import.meta.env.VITE_API_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
    });
}

async function getMe(): Promise<{ username: string }> {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/me`, {
        credentials: 'include',
    });
    if (!response.ok) {
        throw new Error('Not authenticated');
    }
    return response.json();
}

export { getMe, postLogin, postLogout };
